<template>
    <div v-if="price_id && is_price_loaded && is_room_loaded">
        <b-modal
            v-model="show_modal_local"
            :title="'Редактирование цены № '+ price.id "
            class="modal-primary"
            size="xl"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <div class="row">
                <div class="col-lg-6">
                    <ul>
                        <li>Объект: {{ hotel.title }}</li>
                        <li>Номер: {{ price.room.title }} (мест: {{ price.room.places_main }}, дополнительных: {{ price.room.places_additionally }})</li>
                        <li>Программа: {{ price.program.title }}</li>
                        <li>Период: с {{ printDate(_period_start) }} до {{ printDate(_period_end) }} {{ price.period_title }}</li>
                        <li v-if="hotel.calculate_public_prices_using_margin">Тип вознаграждения: Через наценку</li>
                        <li v-if="!hotel.calculate_public_prices_using_margin">Тип вознаграждения: Реферальный</li>
                        <li v-if="!room.allow_book_per_place">Номер продается только целиком</li>
                        <li v-if="room.allow_book_per_place">В номере можно покупать места по-одному</li>
                    </ul>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="calcroomprice" value="1" v-model="calcroomprice" >
                            <label class="custom-control-label" for="calcroomprice">Включить расчет цены за номер из цены за основное место</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" id="weekend_prices" value="1" v-model="price.weekend_prices" @change="onChangeWeekend" >
                            <label class="custom-control-label" for="weekend_prices">Включить ввод отдельных цен на выходные</label>
                        </div>
                    </div>
                </div>
            </div>

            <h4>Цены объекта размещения</h4>

            <div class="row" v-if="weekend_prices">
                <div class="col col-lg-2 bg-secondary">
                </div>
                <div class="col col-lg-5 bg-info text-center">
                    <strong>Будни</strong>
                </div>
                <div class="col col-lg-5 bg-danger  text-center">
                    <strong>Выходные</strong>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <strong></strong>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Весь номер</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Одноместное размещение</strong>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Весь номер</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Одноместное размещение</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary">

                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpf00" v-validate="{ decimal:2, min_value:0, required:true }"  name="rpf00"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpf00')">{{ veeErrors.first('rpf00') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpf01" v-validate="{ decimal:2, min_value:0, required:true }" name="rpf01"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpf01')">{{ veeErrors.first('rpf01') }}</em>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpf02" v-validate="{ decimal:2, min_value:0, required:true }" name="rpf02"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpf02')">{{ veeErrors.first('rpf02') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpf03" v-validate="{ decimal:2, min_value:0, required:true }" name="rpf03"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpf03')">{{ veeErrors.first('rpf03') }}</em>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <div class="row">
                        <div class="col text-center">
                            <strong>Возраст</strong>
                        </div>
                    </div>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Основное место</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Доп место</strong>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Основное место</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Доп место</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <div class="row">
                        <div class="col text-center">
                            <strong>Базовый</strong>
                        </div>
                    </div>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpr00" v-validate="{ decimal:2, min_value:0, required:true }" name="rpr00"  data-vv-as="поле" @input="changeMainPlace"  :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('rpr00')">{{ veeErrors.first('rpr00') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpr01" v-validate="{ decimal:2, min_value:0, required:true }" name="rpr01"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpr01')">{{ veeErrors.first('rpr01') }}</em>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpr02" v-validate="{ decimal:2, min_value:0, required:true }" name="rpr02"  data-vv-as="поле" @input="changeMainPlaceWE"  :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('rpr02')">{{ veeErrors.first('rpr02') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.rpr03" v-validate="{ decimal:2, min_value:0, required:true }" name="rpr03"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpr03')">{{ veeErrors.first('rpr03') }}</em>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-for=" i in [1,2,3,4,5,6]" v-if="useAge(i)">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <div class="row">
                        <div class="col text-center">
                            <strong>от {{i>1? hotel['child_age'+(i-1)]+1 : 0}} до {{hotel['child_age'+i]}}</strong>
                        </div>
                    </div>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['rpr'+i+'0']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'rpr'+i+'0'"  data-vv-as="поле" :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('rpr'+i+'0')">{{ veeErrors.first('rpr'+i+'0') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['rpr'+i+'1']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'rpr'+i+'1'"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpr'+i+'1')">{{ veeErrors.first('rpr'+i+'1') }}</em>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['rpr'+i+'2']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'rpr'+i+'2'"  data-vv-as="поле" :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('rpr'+i+'2')">{{ veeErrors.first('rpr'+i+'2') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['rpr'+i+'3']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'rpr'+i+'3'"  data-vv-as="поле">
                            <em v-if="veeErrors.has('rpr'+i+'3')">{{ veeErrors.first('rpr'+i+'3') }}</em>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center"><small>&nbsp;</small></div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10"> </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices"> </div>
            </div>


            <h4>Публичные цены</h4>

            <div class="row" v-if="weekend_prices">
                <div class="col col-lg-2 bg-secondary">
                </div>
                <div class="col col-lg-5 bg-info text-center">
                    <strong>Будни</strong>
                </div>
                <div class="col col-lg-5 bg-danger  text-center">
                    <strong>Выходные</strong>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <strong></strong>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Весь номер</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Одноместное размещение</strong>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Весь номер</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Одноместное размещение</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary">

                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pf00" v-validate="{ decimal:2, min_value:0, required:true }"  name="pf00"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pf00')">{{ veeErrors.first('pf00') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pf01" v-validate="{ decimal:2, min_value:0, required:true }" name="pf01"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pf01')">{{ veeErrors.first('pf01') }}</em>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pf02" v-validate="{ decimal:2, min_value:0, required:true }" name="pf02"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pf02')">{{ veeErrors.first('pf02') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pf03" v-validate="{ decimal:2, min_value:0, required:true }" name="pf03"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pf03')">{{ veeErrors.first('pf03') }}</em>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <div class="row">
                        <div class="col text-center">
                            <strong>Возраст</strong>
                        </div>
                    </div>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Основное место</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Доп место</strong>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <strong>Основное место</strong>
                        </div>
                        <div class="col-6 text-center">
                            <strong>Доп место</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <div class="row">
                        <div class="col text-center">
                            <strong>Базовый</strong>
                        </div>
                    </div>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pr00" v-validate="{ decimal:2, min_value:0, required:true }" name="pr00"  data-vv-as="поле" @input="changeMainPlace" :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('pr00')">{{ veeErrors.first('pr00') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pr01" v-validate="{ decimal:2, min_value:0, required:true }" name="pr01"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pr01')">{{ veeErrors.first('pr01') }}</em>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pr02" v-validate="{ decimal:2, min_value:0, required:true }" name="pr02"  data-vv-as="поле" @input="changeMainPlaceWE" :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('pr02')">{{ veeErrors.first('pr02') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price.pr03" v-validate="{ decimal:2, min_value:0, required:true }" name="pr03"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pr03')">{{ veeErrors.first('pr03') }}</em>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row" v-for=" i in [1,2,3,4,5,6]" v-if="useAge(i)">
                <div class="col col-lg-2 bg-secondary  text-center">
                    <div class="row">
                        <div class="col text-center">
                            <strong>от {{i>1? hotel['child_age'+(i-1)]+1 : 0}} до {{hotel['child_age'+i]}}</strong>
                        </div>
                    </div>
                </div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['pr'+i+'0']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'pr'+i+'0'"  data-vv-as="поле"  :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('pr'+i+'0')">{{ veeErrors.first('pr'+i+'0') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['pr'+i+'1']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'pr'+i+'1'"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pr'+i+'1')">{{ veeErrors.first('pr'+i+'1') }}</em>
                        </div>
                    </div>
                </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices">
                    <div class="row">
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['pr'+i+'2']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'pr'+i+'2'"  data-vv-as="поле"  :disabled="!room.allow_book_per_place">
                            <em v-if="veeErrors.has('pr'+i+'2')">{{ veeErrors.first('pr'+i+'2') }}</em>
                        </div>
                        <div class="col-6 text-center">
                            <input class="form-control" type="text" v-model.number="price['pr'+i+'3']" v-validate="{ decimal:2, min_value:0, required:true }" :name="'pr'+i+'3'"  data-vv-as="поле">
                            <em v-if="veeErrors.has('pr'+i+'3')">{{ veeErrors.first('pr'+i+'3') }}</em>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-lg-2 bg-secondary  text-center"><small>&nbsp;</small></div>
                <div class="col bg-info" :class="'col-lg-'+weekend_prices?5:10"> </div>
                <div class="col col-lg-5 bg-danger" v-if="weekend_prices"> </div>
            </div>

            <div class="row" style="align-items:center">
                <div class="col col-12">
                    <b-form-group class="form-group" label="Рассчитать публичные цены">
                        <div class="input-group input-group-sm">
                            <select v-model="public_percent" class="form-control">
                                <option :value="null">выберите наценку</option>
                                <option v-for="p in percents" :key="p" :value="p">{{p}}%</option>
                            </select>

                            <select v-model="public_round" class="form-control">
                                <option :value="null">не округлять</option>
                                <option v-for="r in rounds" :key="r" :value="r">{{r}}</option>
                            </select>

                            <button @click="calculatePrices" class="btn btn-sm btn-primary" :disabled="public_percent==null">Рассчитать</button>
                        </div>
                    </b-form-group>
                </div>
            </div>

            <p v-if="price_validation">{{ price_validation.message }}</p>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="onAccept">
                    Сохранить
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить и завершить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_price } from '@/functions_price';
    import { functions_room } from '@/functions_room';

    export default {
        name: 'PriceEditDialog',
        mixins: [functions, functions_price, functions_room],
        data: function () {
            return {
                calcroomprice:true,
                percents:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],
                rounds:[1, 10,20,50,100,200,500],
                adults:[0,1,2,3,4,5,6,7,8,9],
                childs:[0,1,2,3,4,5,6,7,8,9],
                years:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
                public_percent:null,
                public_round:null,
                price_validation: null,
                price_copy: null,
            };
        },
        model: {
            prop: "price_id",
            event: "hide"
        },
        props: {
            price_id: Number,
            hotelx: Object,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                console.log('handleCancel');
                this.$emit("hide", 0);
            },
            handleOk: function () {
                console.log('handleOk');
                this.beforePriceSave();
                this.savePrice(this.price_copy, function (self) {
                    self.$emit("changed", self.price.id);
                    self.$emit("hide", 0);
                }, this);
            },
            onAccept: function () {
                console.log('onAccept');
                this.beforePriceSave();
                this.savePrice(this.price_copy, function (self) {
                    self.$emit("changed", self.price.id);
                }, this);
            },

            onChangeWeekend :function () {
                this.copyWeekend();
            },
            copyWeekend: function () {
                this.price.pf02 = this.price.pf00;
                this.price.pf03 = this.price.pf01;
                this.price.pr02 = this.price.pr00;
                this.price.pr03 = this.price.pr01;
                this.price.pr12 = this.price.pr10;
                this.price.pr13 = this.price.pr11;
                this.price.pr22 = this.price.pr20;
                this.price.pr23 = this.price.pr21;
                this.price.pr32 = this.price.pr30;
                this.price.pr33 = this.price.pr31;
                this.price.pr42 = this.price.pr40;
                this.price.pr43 = this.price.pr41;
                this.price.pr52 = this.price.pr50;
                this.price.pr53 = this.price.pr51;
                this.price.pr62 = this.price.pr60;
                this.price.pr63 = this.price.pr61;
                this.price.rpf03 = this.price.rpf01;
                this.price.rpr02 = this.price.rpr00;
                this.price.rpf02 = this.price.rpf00;
                this.price.rpr03 = this.price.rpr01;
                this.price.rpr12 = this.price.rpr10;
                this.price.rpr13 = this.price.rpr11;
                this.price.rpr22 = this.price.rpr20;
                this.price.rpr23 = this.price.rpr21;
                this.price.rpr32 = this.price.rpr30;
                this.price.rpr33 = this.price.rpr31;
                this.price.rpr42 = this.price.rpr40;
                this.price.rpr43 = this.price.rpr41;
                this.price.rpr52 = this.price.rpr50;
                this.price.rpr53 = this.price.rpr51;
                this.price.rpr62 = this.price.rpr60;
                this.price.rpr63 = this.price.rpr61;
            },

            changeMainPlace: function () {
                if (this.calcroomprice) {
                    this.price.rpf00 = this.price.rpr00 * this.places_main;
                    if (this.places_main == 1) {
                        this.price.rpf01 = this.price.rpf00;
                    }
                }
            },
            changeMainPlaceWE: function () {
                if (this.calcroomprice) {
                    this.price.rpf02 = this.price.rpr02 * this.places_main;
                    if (this.places_main == 1) {
                        this.price.rpf03 = this.price.rpf02;
                    }
                }
            },

            useAge:function (i) {
                switch(i)
                {
                    case 1: return this.use_age_1;
                    case 2: return this.use_age_2;
                    case 3: return this.use_age_3;
                    case 4: return this.use_age_4;
                    case 5: return this.use_age_5;
                    case 6: return this.use_age_6;
                }
                return false;
            },

            calculatePrice:function(p, r,c) {
                name = p + r + '' + c;
                this.price[name] = this.price['r' + name] * (1+this.public_percent/100.0);
                if (this.public_round) {
                    this.price[name] = Math.ceil(Math.round (this.price[name]) / this.public_round) *  this.public_round;
                }
                else {
                    this.price[name] = Math.round (this.price[name]*100)/100;
                }
            },

            calculatePrices:function() {
                this.calculatePrice('pf', 0, 0);
                this.calculatePrice('pf', 0, 1);
                if (this.price.weekend_prices)
                {
                    this.calculatePrice('pf', 0, 2);
                    this.calculatePrice('pf', 0, 3);
                }
                for (let i=0; i<7; i++) {

                    this.calculatePrice('pr', i, 0);
                    this.calculatePrice('pr', i, 1);
                    if (this.price.weekend_prices)
                    {
                        this.calculatePrice('pr', i, 2);
                        this.calculatePrice('pr', i, 3);
                    }
                }

                console.log("this.price['pf00'] = ", this.price['pf00']);
                console.log('this.places_main = ', this.places_main);
                this.price['pr00'] = Math.floor(this.price['pf00'] / this.places_main);
                console.log("this.price['pr00'] = ", this.price['pr00']);
                this.price['pr02'] = Math.floor(this.price['pf02'] / this.places_main);
            },

            validatePrice: function () {
                if (!this.price.weekend_prices) {  this.copyWeekend(); }
                this.$validator.validate().then(result => {
                    if (!result) {
                        alert('Заполните все поля');
                        return;
                    }
                    else {
                        this.price_validation = { result:-1, message:'Выполняеся валидация'};
                        this.httpPrepare();
                        this.$http.put(this.apiurl + 'price/' + this.price.id + '/validate/',  JSON.stringify(this.price) ).then(function (response) {
                            response = this.httpSuccess(response);
                            this.price_validation = response.payload;
                        }, this.httpError)
                    }
                });
            },
            propagatePrice: function () {
                if (!this.price.weekend_prices) {  this.copyWeekend(); }
                this.$validator.validate().then(result => {
                    if (!result) {
                        alert('Заполните все поля');
                        return;
                    }
                    else {
                        this.price_validation = { result:-1, message:'Выполняеся дозаполнение'};
                        this.httpPrepare();
                        this.$http.put(this.apiurl + 'price/' + this.price.id + '/propagate/',  JSON.stringify(this.price) ).then(function (response) {
                            response = this.httpSuccess(response);
                            this.price = response.payload;
                        }, this.httpError)
                    }
                });
            },

            afterPriceLoaded: function (self, payload) {

                this.loadRoom(self.price.room_id, function (self) {
                    self.calcroomprice = self.room.allow_book_per_place;
                }, this);


                self.price.pf00  = self.price.pf00/100;
                self.price.pf02 = self.price.pf02/100;
                self.price.pf01  = self.price.pf01/100;
                self.price.pf03 = self.price.pf03/100;
                self.price.pr00  = self.price.pr00/100;
                self.price.pr02 = self.price.pr02/100;
                self.price.pr01  = self.price.pr01/100;
                self.price.pr03 = self.price.pr03/100;
                self.price.pr10  = self.price.pr10/100;
                self.price.pr12 = self.price.pr12/100;
                self.price.pr11  = self.price.pr11/100;
                self.price.pr13 = self.price.pr13/100;
                self.price.pr20  = self.price.pr20/100;
                self.price.pr22 = self.price.pr22/100;
                self.price.pr21  = self.price.pr21/100;
                self.price.pr23 = self.price.pr23/100;
                self.price.pr30  = self.price.pr30/100;
                self.price.pr32 = self.price.pr32/100;
                self.price.pr31  = self.price.pr31/100;
                self.price.pr33 = self.price.pr33/100;
                self.price.pr40  = self.price.pr40/100;
                self.price.pr42 = self.price.pr42/100;
                self.price.pr41  = self.price.pr41/100;
                self.price.pr43 = self.price.pr43/100;
                self.price.pr50  = self.price.pr50/100;
                self.price.pr52 = self.price.pr52/100;
                self.price.pr51  = self.price.pr51/100;
                self.price.pr53 = self.price.pr53/100;
                self.price.pr60  = self.price.pr60/100;
                self.price.pr62 = self.price.pr62/100;
                self.price.pr61  = self.price.pr61/100;
                self.price.pr63 = self.price.pr63/100;
                self.price.rpf01  = self.price.rpf01/100;
                self.price.rpf03 = self.price.rpf03/100;
                self.price.rpr00  = self.price.rpr00/100;
                self.price.rpr02 = self.price.rpr02/100;
                self.price.rpf00  = self.price.rpf00/100;
                self.price.rpf02 = self.price.rpf02/100;
                self.price.rpr01  = self.price.rpr01/100;
                self.price.rpr03 = self.price.rpr03/100;
                self.price.rpr10  = self.price.rpr10/100;
                self.price.rpr12 = self.price.rpr12/100;
                self.price.rpr11  = self.price.rpr11/100;
                self.price.rpr13 = self.price.rpr13/100;
                self.price.rpr20  = self.price.rpr20/100;
                self.price.rpr22 = self.price.rpr22/100;
                self.price.rpr21  = self.price.rpr21/100;
                self.price.rpr23 = self.price.rpr23/100;
                self.price.rpr30  = self.price.rpr30/100;
                self.price.rpr32 = self.price.rpr32/100;
                self.price.rpr31  = self.price.rpr31/100;
                self.price.rpr33 = self.price.rpr33/100;
                self.price.rpr40  = self.price.rpr40/100;
                self.price.rpr42 = self.price.rpr42/100;
                self.price.rpr41  = self.price.rpr41/100;
                self.price.rpr43 = self.price.rpr43/100;
                self.price.rpr50  = self.price.rpr50/100;
                self.price.rpr52 = self.price.rpr52/100;
                self.price.rpr51  = self.price.rpr51/100;
                self.price.rpr53 = self.price.rpr53/100;
                self.price.rpr60  = self.price.rpr60/100;
                self.price.rpr62 = self.price.rpr62/100;
                self.price.rpr61  = self.price.rpr61/100;
                self.price.rpr63 = self.price.rpr63/100;
            },

            beforePriceSave: function () {
                this.price_copy =  Object.assign({}, this.price);
                this.price_copy.pf00  = Math.round(this.price_copy.pf00*100);
                this.price_copy.pf02 = Math.round(this.price_copy.pf02*100);
                this.price_copy.pf01  = Math.round(this.price_copy.pf01*100);
                this.price_copy.pf03 = Math.round(this.price_copy.pf03*100);
                this.price_copy.pr00  = Math.round(this.price_copy.pr00*100);
                this.price_copy.pr02 = Math.round(this.price_copy.pr02*100);
                this.price_copy.pr01  = Math.round(this.price_copy.pr01*100);
                this.price_copy.pr03 = Math.round(this.price_copy.pr03*100);
                this.price_copy.pr10  = Math.round(this.price_copy.pr10*100);
                this.price_copy.pr12 = Math.round(this.price_copy.pr12*100);
                this.price_copy.pr11  = Math.round(this.price_copy.pr11*100);
                this.price_copy.pr13 = Math.round(this.price_copy.pr13*100);
                this.price_copy.pr20  = Math.round(this.price_copy.pr20*100);
                this.price_copy.pr22 = Math.round(this.price_copy.pr22*100);
                this.price_copy.pr21  = Math.round(this.price_copy.pr21*100);
                this.price_copy.pr23 = Math.round(this.price_copy.pr23*100);
                this.price_copy.pr30  = Math.round(this.price_copy.pr30*100);
                this.price_copy.pr32 = Math.round(this.price_copy.pr32*100);
                this.price_copy.pr31  = Math.round(this.price_copy.pr31*100);
                this.price_copy.pr33 = Math.round(this.price_copy.pr33*100);
                this.price_copy.pr40  = Math.round(this.price_copy.pr40*100);
                this.price_copy.pr42 = Math.round(this.price_copy.pr42*100);
                this.price_copy.pr41  = Math.round(this.price_copy.pr41*100);
                this.price_copy.pr43 = Math.round(this.price_copy.pr43*100);
                this.price_copy.pr50  = Math.round(this.price_copy.pr50*100);
                this.price_copy.pr52 = Math.round(this.price_copy.pr52*100);
                this.price_copy.pr51  = Math.round(this.price_copy.pr51*100);
                this.price_copy.pr53 = Math.round(this.price_copy.pr53*100);
                this.price_copy.pr60  = Math.round(this.price_copy.pr60*100);
                this.price_copy.pr62 = Math.round(this.price_copy.pr62*100);
                this.price_copy.pr61  = Math.round(this.price_copy.pr61*100);
                this.price_copy.pr63 = Math.round(this.price_copy.pr63*100);
                this.price_copy.rpf01  = Math.round(this.price_copy.rpf01*100);
                this.price_copy.rpf03 = Math.round(this.price_copy.rpf03*100);
                this.price_copy.rpr00  = Math.round(this.price_copy.rpr00*100);
                this.price_copy.rpr02 = Math.round(this.price_copy.rpr02*100);
                this.price_copy.rpf00  = Math.round(this.price_copy.rpf00*100);
                this.price_copy.rpf02 = Math.round(this.price_copy.rpf02*100);
                this.price_copy.rpr01  = Math.round(this.price_copy.rpr01*100);
                this.price_copy.rpr03 = Math.round(this.price_copy.rpr03*100);
                this.price_copy.rpr10  = Math.round(this.price_copy.rpr10*100);
                this.price_copy.rpr12 = Math.round(this.price_copy.rpr12*100);
                this.price_copy.rpr11  = Math.round(this.price_copy.rpr11*100);
                this.price_copy.rpr13 = Math.round(this.price_copy.rpr13*100);
                this.price_copy.rpr20  = Math.round(this.price_copy.rpr20*100);
                this.price_copy.rpr22 = Math.round(this.price_copy.rpr22*100);
                this.price_copy.rpr21  = Math.round(this.price_copy.rpr21*100);
                this.price_copy.rpr23 = Math.round(this.price_copy.rpr23*100);
                this.price_copy.rpr30  = Math.round(this.price_copy.rpr30*100);
                this.price_copy.rpr32 = Math.round(this.price_copy.rpr32*100);
                this.price_copy.rpr31  = Math.round(this.price_copy.rpr31*100);
                this.price_copy.rpr33 = Math.round(this.price_copy.rpr33*100);
                this.price_copy.rpr40  = Math.round(this.price_copy.rpr40*100);
                this.price_copy.rpr42 = Math.round(this.price_copy.rpr42*100);
                this.price_copy.rpr41  = Math.round(this.price_copy.rpr41*100);
                this.price_copy.rpr43 = Math.round(this.price_copy.rpr43*100);
                this.price_copy.rpr50  = Math.round(this.price_copy.rpr50*100);
                this.price_copy.rpr52 = Math.round(this.price_copy.rpr52*100);
                this.price_copy.rpr51  = Math.round(this.price_copy.rpr51*100);
                this.price_copy.rpr53 = Math.round(this.price_copy.rpr53*100);
                this.price_copy.rpr60  = Math.round(this.price_copy.rpr60*100);
                this.price_copy.rpr62 = Math.round(this.price_copy.rpr62*100);
                this.price_copy.rpr61  = Math.round(this.price_copy.rpr61*100);
                this.price_copy.rpr63 = Math.round(this.price_copy.rpr63*100);
            },
        },


        computed: {
            show_modal_local: {
                get: function () {
                    return !!this.price_id
                },
                set: function (newValue) {}
            },
            weekend_prices: function(){
                return this.price.weekend_prices;
            },
            use_age_1 :function () {
                return (this.hotel.tarif_type1 == 1);
            },
            use_age_2 :function () {
                return (this.hotel.child_age1<17) && (this.hotel.tarif_type2==1);
            },
            use_age_3 :function () {
                return (this.hotel.child_age2<17) && (this.hotel.tarif_type3==1);
            },
            use_age_4 :function () {
                return (this.hotel.child_age3<17) && (this.hotel.tarif_type4==1);
            },
            use_age_5 :function () {
                return (this.hotel.child_age4<17) && (this.hotel.tarif_type5==1);
            },
            use_age_6 :function () {
                return (this.hotel.child_age5<17) && (this.hotel.tarif_type6==1);
            },
            places_main: function () {
                if (this.is(this.price.room.places_main) && this.price.room.places_main > 0) {
                    return this.price.room.places_main;
                }
                return 1;
            },
            _period_start : {
                get: function () {
                    if (!this.is(this.price.period.date_period_begin_iso)) return null;
                    return new Date(this.price.period.date_period_begin_iso.slice(0, 10));
                },
                set: function (v) {
                    this.period.price.date_period_begin_iso = dateToISO(v);
                }
            },

            _period_end : {
                get: function () {
                    if (!this.is(this.price.period.date_period_end_iso)) return null;
                    return new Date(this.price.period.date_period_end_iso.slice(0, 10));
                },
                set: function (v) {
                    this.period.price.date_period_end_iso = dateToISO(v);
                }
            },
        },
        created: function() {
            this.loadPrice(this.price_id, this.afterPriceLoaded, this);
            this.hotel = this.hotelx;

            if (this.hotel.calculate_public_prices_using_margin) {
                this.public_percent = this.hotel.procent_ref_obj;
            }
            else {
                this.public_percent = 0;
            }
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            //console.log('SimpleDialog: updated');
        },
    }
</script>
